var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"sc-user-input--button-icon-wrapper"},[_c('svg',{attrs:{"viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}},[_c('title',{attrs:{"id":"send-icon"}},[_vm._v(_vm._s(_vm.$t('Send')))]),_c('path',{attrs:{"d":"M4.02 42l41.98-18-41.98-18-.02 14 30 4-30 4z"}}),_c('path',{attrs:{"d":"M0 0h48v48h-48z","fill":"none"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }